import { useTranslation } from 'react-i18next'

import { QA_NAME_CLOSE_BTN } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'
import Button from '../../Button'
import Text from '../../Text'

import { CalendarGridCardTitle } from './CalendarGridCardTitle'

import * as styles from './CalendarGridCard.module.css'

import CloseIcon from '../../../icons/close.svg'

function CalendarGridCard({
  Actions,
  HeaderContent,
  actionsProps,
  children,
  headerContentProps,
  headerText,
  qaName,
  title,
  titleUrl,
  onClose,
}) {
  const { t } = useTranslation()

  return (
    <div
      {...getQaSelector({ value: qaName })}
      className={styles.CalendarGridCard}
    >
      <div className={styles.header}>
        {HeaderContent ? (
          <HeaderContent {...headerContentProps} />
        ) : (
          <Text isSecondary>{headerText}</Text>
        )}
        {onClose ? (
          <Button.Icon
            isGrey
            Icon={CloseIcon}
            className={styles.close}
            qaName={QA_NAME_CLOSE_BTN}
            tooltip={t('Calendar.CardCloseTooltipKey')}
            onClick={onClose}
          />
        ) : null}
      </div>
      {title ? (
        <CalendarGridCardTitle title={title} titleUrl={titleUrl} />
      ) : null}
      {children}
      {Actions ? <Actions {...actionsProps} /> : null}
    </div>
  )
}

export default CalendarGridCard
